import { Box } from '@apia/theme';
import { TRoles } from '../../../../../objects/costs/activities/structure';
import { TLabel, objects } from '../../../../../objects/constants';
import { hoursPerSquare } from './RolesHoursCount';
import { EventEmitter, useMount } from '@apia/util';
import { useState } from 'react';

const hoverEmitter = new (class HoverEmitter extends EventEmitter<{
  which: string;
}> {})();

export const RolesHoursDetails = ({
  details,
  label,
}: {
  details: Record<TRoles, number | string>;
  label: string;
}) => {
  const [hover, setHover] = useState('');

  useMount(() => {
    return hoverEmitter.on('which', setHover);
  });

  return (
    <Box className="proposal__week__details">
      <strong>{label}</strong>
      <Box className="proposal__week__roles">
        {Object.entries(details).map(([role, hours]) => {
          return (
            <Box
              key={role}
              className={hover === role ? 'hover' : ''}
              onMouseEnter={() => {
                hoverEmitter.emit('which', role);
              }}
              onMouseLeave={() => {
                hoverEmitter.emit('which', '');
              }}
            >
              <strong>{objects.labels[role as TLabel]()}: </strong>
              {typeof hours === 'number'
                ? objects.labels.schedulePeopleCount(
                    (hours / hoursPerSquare).toFixed(2),
                  )
                : hours}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
